import React from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import { motion, AnimatePresence } from "framer-motion";
import { useState } from "react";
import "../styles/ClubhouseSerene.css";

// demo images (replace with your images)
import Img1 from "../assets/serene-images/aerial-view-serene.avif";
import Img2 from "../assets/serene-images/GATE-ELONGATED.avif";
import Img3 from "../assets/serene-images/STREET-DRIVE.avif";
import Img4 from "../assets/serene-images/AMPHITHEATER-AND-SUNKEN-SEATING.avif";
import Img5 from "../assets/serene-images/BASKETBALL-COURT.avif";
import Img6 from "../assets/serene-images/BRIDGEWAY.avif";
import Img7 from "../assets/serene-images/KIDS-PLAY-AREA.avif";
import Img8 from "../assets/serene-images/SCULPTURE-WATERBODIES.avif";
import Img9 from "../assets/serene-images/VILLA-FRONT-PERGOLLA-LAWN.avif";
import Img10 from "../assets/serene-images/WATER-FEATURE.avif";
import img4 from "../assets/icons/shuttlecock.png";
import img5 from "../assets/icons/snooker.png";
import img6 from "../assets/icons/Garden.png";
import img7 from "../assets/icons/meeting-room.png";
import img8 from "../assets/icons/Gym.png";
import img9 from "../assets/icons/ping-pong.png";
import img10 from "../assets/icons/air-hockey.png";
import img11 from "../assets/icons/Board.png";
import img12 from "../assets/icons/Conference.png";
import img13 from "../assets/icons/Hall.png";

// Floor plan images
import clubHouse1 from "../assets/serene-images/club-house-1.webp";
import clubHouse2 from "../assets/serene-images/club-house-2.webp";
import clubHouse3 from "../assets/serene-images/club-house-3.webp";
import clubHouse4 from "../assets/serene-images/club-house-4.webp";
import clubHouse5 from "../assets/serene-images/club-house-5.webp";

import SereneIllustration from "../assets/serene-images/serene-clubhouse-cutout.avif";


export default function Clubhouse() {

    const [selectedPlan, setSelectedPlan] = useState(null);
    const [activeFloorIndex, setActiveFloorIndex] = useState(0);

    const floorPlanData = [
        {
            img: clubHouse1, // Placeholder
            title: "GROUND FLOOR PLAN",
            details: null,
            description: "LEGEND",
            points: [
                "Grand Reception Hall – 18' 2\" × 35' 2\"",
                "Grand Lounge – 13' 2\" × 18' 0\"",
                "Admin Room – 22' 10\" × 8' 6\"",
                "Gents Washroom – 16' 5\" × 13' 4\"",
                "Service Lift – 6' 0\" × 6' 0\"",
                "Ladies Washroom – 11' 0\" × 11' 7\"",
                "Lift – 6' 6\" × 8' 3\"",
                "Banquet Hall – 42' 2\" × 25' 3\"",
                "Kitchen – 18' 0\" × 9' 11\"",
                "Deck – 13' 4\" × 27' 8\""
            ]
        },
        {
            img: clubHouse2, // Placeholder
            title: "FIRST FLOOR PLAN",
            details: null,
            description: "LEGEND",
            points: [
                "Badminton Court – 54' 10\" × 27' 2\"",
                "Gents Washroom – 16' 5\" × 13' 4\"",
                "Service Lift – 6' 0\" × 6' 0\"",
                "Ladies Washroom – 11' 0\" × 11' 7\"",
                "Lift – 6' 6\" × 8' 3\"",
                "Lounge – 15' 8\" × 19' 10\"",
                "Gymnasium I – 25' 10\" × 63' 8\"",
                "Store – 5' 0\" × 7' 4\""
            ]
        },
        {
            img: clubHouse3, // Placeholder
            title: "SECOND FLOOR PLAN",
            details: null,
            description: "LEGEND",
            points: [
                "Gymnasium – 42' 2\" × 46' 6\"",
                "Landscape Garden – 44' 10\" × 17' 2\"",
                "Doctors Room – 11' 0\" × 10' 8\"",
                "Conference Room – 22' 7\" × 16' 0\"",
                "Service Lift – 6' 0\" × 6' 0\"",
                "Lift – 6' 6\" × 8' 3\""
            ]
        },
        {
            img: clubHouse1, // Reusing Placeholder
            title: "THIRD FLOOR PLAN",
            details: null,
            description: "LEGEND",
            points: [
                "Guest Room 1 – 20' 3\" × 14' 0\"",
                "Guest Room 2 – 13' 4\" × 21' 6\"",
                "Guest Room 3 – 20' 0\" × 13' 6\"",
                "Toilet 2 – 11' 8\" × 6' 5\"",
                "Toilet 1 – 10' 11\" × 6' 3\"",
                "Toilet 3 – 11' 8\" × 6' 3\"",
                "Lounge – 11' 0\" × 21' 2\"",
                "Multipurpose Hall – 16' 6\" × 21' 9\"",
                "Lift – 6' 6\" × 8' 3\"",
                "Lounge – 11' 0\" × 10' 5\"",
                "Lobby – 10' 0\" × 5' 1\"",
                "Toilet – 10' 0\" × 4' 9\"",
                "Massage 2 – 8' 7\" × 10' 2\"",
                "Massage 1 – 11' 4\" × 9' 4\"",
                "Toilet – 4' 9\" × 9' 4\"",
                "Indoor Games – 39' 2\" × 29' 6\"",
                "Table Tennis – 15' 0\" × 27' 2\"",
                "Service Lift – 6' 0\" × 6' 0\""
            ]
        },
        {
            img: clubHouse2, // Reusing Placeholder
            title: "TERRACE FLOOR PLAN",
            details: null,
            description: "LEGEND",
            points: [
                "Kids Pool – 18' 6\" × 16' 6\"",
                "Main Pool – 18' 0\" × 63' 8\"",
                "Seating Deck – 17' 10\" × 11' 3\"",
                "Ladies Washroom – 12' 10\" × 12' 1\"",
                "Gents Washroom – 10' 0\" × 15' 1\"",
                "Lobby – 18' 10\" × 15' 8\"",
                "Lift – 6' 6\" × 8' 3\"",
                "Multipurpose Hall – 23' 1\" × 20' 6\"",
                "Service Lift – 6' 0\" × 6' 0\"",
                "Terrace Garden – 52' 9\" × 26' 6\"",
                "Store – 11' 0\" × 4' 5\""
            ]
        }
    ];
    const features = [
        { title: "Badminton Court", icon: img4, type: "img" },
        { title: "Billiards Zone", icon: img5, type: "img" },
        { title: "Landscape / Garden", icon: img6, type: "img" },
        { title: "Meeting Room", icon: img7, type: "img" },
        { title: "Gymnasium", icon: img8, type: "img" },
        { title: "Ping Pong", icon: img9, type: "img" },
        { title: "Air Hockey Zone", icon: img10, type: "img" },
        { title: "Board Games Zone", icon: img11, type: "img" },
        { title: "Conference Room", icon: img12, type: "img" },
        { title: "Multipurpose Hall", icon: img13, type: "img" },
    ];

    // ✅ Whole section stagger animation
    const sectionStagger = {
        hidden: {},
        show: {
            transition: {
                staggerChildren: 0.06,
                delayChildren: 0.04,
            },
        },
    };

    // ✅ Bottom → Top + fade + blur (premium)
    const fadeUp = {
        hidden: { opacity: 0, y: 45, filter: "blur(10px)" },
        show: {
            opacity: 1,
            y: 0,
            filter: "blur(0px)",
            transition: { duration: 0.45, ease: "easeOut" },
        },
    };

    // ✅ Title luxury 3D entry
    const text3D = {
        hidden: {
            opacity: 0,
            y: 60,
            rotateX: 12,
            filter: "blur(10px)",
        },
        show: {
            opacity: 1,
            y: 0,
            rotateX: 0,
            filter: "blur(0px)",
            transition: {
                duration: 0.5,
                ease: [0.22, 1, 0.36, 1],
            },
        },
    };

    // ✅ Feature grid stagger
    const featureGrid = {
        hidden: {},
        show: {
            transition: {
                staggerChildren: 0.04,
                delayChildren: 0.06,
            },
        },
    };

    // ✅ Each feature card animation
    const featureItem = {
        hidden: { opacity: 0, y: 30, scale: 0.98 },
        show: {
            opacity: 1,
            y: 0,
            scale: 1,
            transition: { duration: 0.3, ease: "easeOut" },
        },
    };

    // ✅ Slider container animation (fade)
    const sliderVariant = {
        hidden: { opacity: 0, y: 35, scale: 0.98, filter: "blur(12px)" },
        show: {
            opacity: 1,
            y: 0,
            scale: 1,
            filter: "blur(0px)",
            transition: { duration: 0.5, ease: "easeOut" },
        },
    };

    // ✅ Bottom line animation
    const lineVariant = {
        hidden: { opacity: 0, scaleX: 0 },
        show: {
            opacity: 1,
            scaleX: 1,
            transition: { duration: 0.5, ease: "easeOut" },
        },
    };

    // ✅ Word by word animation (same as your H1)
    const wordContainer = {
        hidden: {},
        show: {
            transition: {
                staggerChildren: 0.04,
                delayChildren: 0.06,
            },
        },
    };

    const wordVariant = {
        hidden: { y: 35, opacity: 0, filter: "blur(6px)" },
        show: {
            y: 0,
            opacity: 1,
            filter: "blur(0px)",
            transition: { duration: 0.4, ease: "easeOut" },
        },
    };

    // ✅ split title words
    // ✅ remove starting space also
    const line1 = "Lifestyle Amenities That".split(" ");
    const line2 = "Redefine Living".split(" ");



    return (
        <motion.section
            className="clubhouse-section py-lg-5"
            id="serene-amenities"
            initial="hidden"
        >
            <div className="container py-lg-5">
                {/* Top Heading */}
                <div className="row">


                    <div className="col-lg-7 d-flex align-items-center mt-4 mt-lg-0">

                        <motion.h2
                            className="sage-title display-4"
                            variants={wordContainer}
                            initial="hidden"
                            whileInView="show"
                            viewport={{ once: true, amount: 0.6 }}
                        >
                            {line1.map((word, i) => (
                                <motion.span
                                    key={`line1-${i}`}
                                    variants={wordVariant}
                                    style={{ display: "inline-block", marginRight: "0.35em" }}
                                >
                                    {word}
                                </motion.span>
                            ))}

                            <br />

                            {line2.map((word, i) => (
                                <motion.span
                                    key={`line2-${i}`}
                                    variants={wordVariant}
                                    style={{ display: "inline-block", marginRight: "0.35em" }}
                                >
                                    {word}
                                </motion.span>
                            ))}
                        </motion.h2>

                    </div>
                    <div className="col-lg-5 d-flex justify-content-center flex-column">


                        <motion.p className="about-text mb-0" variants={fadeUp} initial="hidden" whileInView="show" viewport={{ once: true, amount: 0.6 }}>
                            Serene offers a curated range of lifestyle amenities designed to enrich everyday living with comfort and sophistication. From serene green spaces to thoughtfully crafted leisure areas, every amenity enhances a life of balance and elegance.
                        </motion.p>
                    </div>
                </div>
                <div className="mt-4" style={{ width: "100%", height: "1px", backgroundColor: "#0c4b4f" }}></div>

                <div className="row align-items-center g-4 py-lg-5">
                    {/* LEFT SIDE */}
                    <div className="col-lg-6 p-lg-0 p-4">
                        {/* ✅ feature grid with stagger */}
                        <motion.div className="clubhouse-grid" variants={featureGrid} initial="hidden" whileInView="show" viewport={{ once: true, amount: 0.6 }}>
                            {features.map((item, index) => (
                                <motion.div className="col-lg-6" key={index} variants={featureItem}>
                                    <div className="clubhouse-feature rounded-2">
                                        <span className="clubhouse-icon">
                                            {item.type === "img" ? (
                                                <img
                                                    src={item.icon}
                                                    alt={item.title}
                                                    className="clubhouse-icon-img"
                                                />
                                            ) : (
                                                item.icon
                                            )}
                                        </span>
                                        <span className="clubhouse-text">{item.title}</span>
                                    </div>
                                </motion.div>
                            ))}
                        </motion.div>
                    </div>

                    {/* RIGHT SIDE - Slider */}
                    <motion.div className="col-lg-6 p-lg-0" variants={sliderVariant} initial="hidden" whileInView="show" viewport={{ once: true, amount: 0.6 }}>
                        <div className="clubhouse-slider-wrap d-none">
                            <div
                                id="clubhouseCarousel"
                                className="carousel slide"
                                data-bs-ride="carousel"
                            >
                                <div className="carousel-inner rounded-2">
                                    <div className="carousel-item active">
                                        <img
                                            src={Img1}
                                            className="d-block w-100 clubhouse-img"
                                            alt="slide1"
                                        />
                                    </div>
                                    <div className="carousel-item">
                                        <img
                                            src={Img2}
                                            className="d-block w-100 clubhouse-img"
                                            alt="slide2"
                                        />
                                    </div>
                                    <div className="carousel-item">
                                        <img
                                            src={Img3}
                                            className="d-block w-100 clubhouse-img"
                                            alt="slide3"
                                        />
                                    </div>
                                    <div className="carousel-item">
                                        <img
                                            src={Img4}
                                            className="d-block w-100 clubhouse-img"
                                            alt="slide4"
                                        />
                                    </div>
                                    <div className="carousel-item">
                                        <img
                                            src={Img5}
                                            className="d-block w-100 clubhouse-img"
                                            alt="slide5"
                                        />
                                    </div>
                                    <div className="carousel-item">
                                        <img
                                            src={Img6}
                                            className="d-block w-100 clubhouse-img"
                                            alt="slide6"
                                        />
                                    </div>
                                    <div className="carousel-item">
                                        <img
                                            src={Img7}
                                            className="d-block w-100 clubhouse-img"
                                            alt="slide7"
                                        />
                                    </div>
                                    <div className="carousel-item">
                                        <img
                                            src={Img8}
                                            className="d-block w-100 clubhouse-img"
                                            alt="slide8"
                                        />
                                    </div>
                                    <div className="carousel-item">
                                        <img
                                            src={Img9}
                                            className="d-block w-100 clubhouse-img"
                                            alt="slide9"
                                        />
                                    </div>
                                    <div className="carousel-item">
                                        <img
                                            src={Img10}
                                            className="d-block w-100 clubhouse-img"
                                            alt="slide10"
                                        />
                                    </div>
                                </div>

                                {/* LEFT ARROW */}
                                <button
                                    className="carousel-control-prev clubhouse-arrow"
                                    type="button"
                                    data-bs-target="#clubhouseCarousel"
                                    data-bs-slide="prev"
                                >
                                    <span className="clubhouse-arrow-box">
                                        <span className="carousel-control-prev-icon" />
                                    </span>
                                </button>

                                {/* RIGHT ARROW */}
                                <button
                                    className="carousel-control-next clubhouse-arrow"
                                    type="button"
                                    data-bs-target="#clubhouseCarousel"
                                    data-bs-slide="next"
                                >
                                    <span className="clubhouse-arrow-box">
                                        <span className="carousel-control-next-icon" />
                                    </span>
                                </button>
                            </div>
                        </div>
                        <img className="img-fluid serene-illustration-shadow" src={SereneIllustration} alt="" />
                    </motion.div>
                </div>

                {/* Floor Plans Section */}
                <div className="row g-4 justify-content-center d-none d-lg-flex">
                    {floorPlanData.map((item, index) => (
                        <div className="col-lg-4 col-md-6" key={index}>
                            <motion.div
                                className="floor-plan-card"
                                initial={{ opacity: 0, y: 30 }}
                                whileInView={{ opacity: 1, y: 0 }}
                                transition={{ duration: 0.3, delay: index * 0.06 }}
                                viewport={{ once: true, amount: 0.6 }}
                                onClick={() => setSelectedPlan(item)}
                            >
                                <img src={item.img} alt={item.title} className="floor-plan-img img-fluid" />
                                <div className="floor-plan-overlay">
                                    <span className="floor-plan-text p-2 rounded-3">Click for Details</span>
                                </div>
                                <p className="text-center mt-3 fw-semibold" style={{ color: "#0c4b4f" }}>{item.title}</p>
                            </motion.div>
                        </div>
                    ))}
                </div>

                <div className="floor-plan-mobile d-lg-none">
                    <div className="floor-plan-mobile-tabs mb-3 align-items-center justify-content-md-center">
                        {floorPlanData.map((item, index) => (
                            <button
                                key={item.title}
                                type="button"
                                className={`floor-plan-mobile-tab ${activeFloorIndex === index ? "active" : ""}`}
                                onClick={() => setActiveFloorIndex(index)}
                            >
                                <span className="floor-plan-mobile-tab-label">
                                    {item.title.replace(" FLOOR PLAN", "")}
                                </span>
                            </button>
                        ))}
                    </div>

                    <motion.div
                        className="floor-plan-mobile-feature mb-4"
                        initial={{ opacity: 0, y: 30 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        transition={{ duration: 0.3 }}
                        viewport={{ once: true, amount: 0.6 }}
                        onClick={() => setSelectedPlan(floorPlanData[activeFloorIndex])}
                    >
                        <div className="floor-plan-mobile-media">
                            <img
                                src={floorPlanData[activeFloorIndex].img}
                                alt={floorPlanData[activeFloorIndex].title}
                                className="floor-plan-mobile-img img-fluid"
                            />
                        </div>
                        <div className="floor-plan-mobile-content">
                            <p className="floor-plan-mobile-title mb-2">
                                {floorPlanData[activeFloorIndex].title}
                            </p>
                            <div className="floor-plan-mobile-meta">
                                <span>{floorPlanData[activeFloorIndex].points.length} Spaces</span>
                                <span>Tap for Details</span>
                            </div>
                        </div>
                    </motion.div>
                </div>


                {/* Bottom line */}
                {/* <motion.div
                    className="clubhouse-bottom-line mt-5"
                    variants={lineVariant}
                    style={{ transformOrigin: "left" }}
                /> */}
            </div>
            {/* POPUP MODAL */}
            <AnimatePresence>
                {selectedPlan && (
                    <motion.div
                        className="floor-plan-popup-overlay"
                        initial={{ opacity: 0 }}
                        animate={{ opacity: 1 }}
                        exit={{ opacity: 0 }}
                        onClick={() => setSelectedPlan(null)} // Close on backdrop click
                    >
                        <motion.div
                            className="floor-plan-popup-content"
                            initial={{ scale: 0.9, opacity: 0, y: 20 }}
                            animate={{ scale: 1, opacity: 1, y: 0 }}
                            exit={{ scale: 0.9, opacity: 0, y: 20 }}
                            transition={{ type: "spring", damping: 25, stiffness: 300 }}
                            onClick={(e) => e.stopPropagation()} // Prevent closing when clicking content
                        >
                            <button className="popup-close-btn" onClick={() => setSelectedPlan(null)}>
                                &times;
                            </button>
                            <div className="popup-scroll-area">
                                <div className="row">
                                    <div className="col-lg-6">
                                        <h3 className="floor-details-title">
                                            {selectedPlan.title}
                                            {selectedPlan.subTitle && <span className="d-block mt-1 fs-6 opacity-75">{selectedPlan.subTitle}</span>}
                                        </h3>
                                        <div className="floor-details-body">
                                            {selectedPlan.description && <h5 className="mb-3 text-uppercase" style={{ letterSpacing: "1px", color: "#0c4b4f" }}>{selectedPlan.description}</h5>}

                                            {selectedPlan.points ? (
                                                <ol className="ps-3 mb-0">
                                                    {selectedPlan.points.map((point, i) => (
                                                        <li key={i} className="mb-2">{point}</li>
                                                    ))}
                                                </ol>
                                            ) : (
                                                selectedPlan.details
                                            )}
                                        </div>
                                    </div>
                                    <div className="col-lg-6 d-flex align-items-center justify-content-center mt-4 mt-lg-0">
                                        <img
                                            src={selectedPlan.img}
                                            alt={selectedPlan.title}
                                            className="img-fluid rounded-3"
                                            style={{ maxHeight: '400px', objectFit: 'contain' }}
                                        />
                                    </div>
                                </div>
                            </div>
                        </motion.div>
                    </motion.div>
                )}
            </AnimatePresence>

        </motion.section>
    );
}
